import { useEffect } from 'react'
import { loadCookieConsent } from '../utils/marketingAnalytics'

/** Load Osano (cookie consent) on a public page that sends no marketing events, such as login. */
export function useCookieConsent(): void {
  useEffect(() => {
    loadCookieConsent()
  }, [])
}
